// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n'; // Initialize i18n
import { AuthProvider } from './context/AuthContext'; // ✅ Correct path

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ✅ Wrap App here */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Optional: remove if not using performance monitoring
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();
